import React, { useEffect, useRef } from 'react'
import { SplashScreen } from './screens/SplashScreen/SplashScreen'
import './App.css'
import { AppExecutor } from './executors/AppExecutor'
import { useSceneStore } from './state/gameState'
import { Scenes } from './constants/game'
import { IntroScreen } from './screens/IntroScreen/IntroScreen'
import { WhoLivesQuestionScreen } from './screens/WhoLivesQuestionScreen/WhoLivesQuestionScreen'
import { SentenceVictimScreen } from './screens/SentenceVictimScreen/SentenceVictimScreen'
import { DecisionStatsScreen } from './screens/DecisionStatsScreen/DecisionStatsScreen'
import { VerdictScreen } from './screens/VerdictScreen/VerdictScreen'
import { MuteButton } from './components/MuteButton/MuteButton'
import { CaptionBar } from './components/CaptionBar/CaptionBar'
import { Analytics } from '@vercel/analytics/react'

const App = () => {
  const currentScene = useSceneStore((state) => state.currentScene)
  const setScene = useSceneStore((state) => state.setScene)
  // Lazy ref (not useMemo): one executor per committed mount. A dev-only
  // StrictMode double-render may still construct a discarded duplicate, so
  // the constructor chain must stay free of persisted side effects.
  const executorRef = useRef<AppExecutor | null>(null)
  if (executorRef.current === null) {
    executorRef.current = new AppExecutor(setScene)
  }
  const executor = executorRef.current

  useEffect(() => {
    void executor.exec()
  }, [executor])

  return (
    <div className="appContainer">
      <h1 className="visuallyHidden">
        Trollilopolis — the unhinged trolley problem game. You are the trolley.
        Decide who lives and who dies.
      </h1>
      {currentScene === Scenes.Splash && (
        <SplashScreen
          setScene={setScene}
          {...executor.getSplashScreenProps()}
        />
      )}
      {currentScene === Scenes.Intro && (
        <IntroScreen setScene={setScene} {...executor.getIntroScreenProps()} />
      )}

      {currentScene === Scenes.WhoLivesQuestion && (
        <WhoLivesQuestionScreen
          setScene={setScene}
          {...executor.getWhoLivesQuestionScreenProps()}
        />
      )}

      {currentScene === Scenes.SentenceVictim && (
        <SentenceVictimScreen
          setScene={setScene}
          {...executor.getSentenceVictimScreenProps()}
        />
      )}

      {currentScene === Scenes.DecisionStats && (
        <DecisionStatsScreen
          setScene={setScene}
          {...executor.getDecisionStatsScreenProps()}
        />
      )}

      {currentScene === Scenes.Verdict && (
        <VerdictScreen
          setScene={setScene}
          {...executor.getVerdictScreenProps()}
        />
      )}
      <CaptionBar />
      <MuteButton />
      <Analytics />
    </div>
  )
}

export default App
